export enum ContractStatusEnum {
  NOT_SIGNED = "CONTRACT_STATUS_ENUM_NOT_SIGNED",
  SIGNED = "CONTRACT_STATUS_ENUM_SIGNED",
  ALL = "CONTRACT_STATUS_ENUM_ALL",
}

export enum ContractStatusValue {
  NOT_SIGNED = "not_signed",
  SIGNED = "signed",
}
